import { useEffect, useState } from "react";
import { _single, _TaxCode } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../../theme/Component/BasicButton"
import { TaxCodeSchemeEditor } from "../../TaxCodeScheme/TaxCodeScheme.editor";
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX";

interface Props {
    closeModal: Function;
}


export const ImportFileTaxCode = ({ closeModal }: Props) => {

    const taxCode = useDataBean(_TaxCode);
    const [document, setDocument] = useState<any>({})
    const [codeScheme, setCodeScheme] = useState<number>(null);
    const [lista, setLista] = useState<any>([]);
    const [importado, setImportado] = useState<any>([]);
    const [failedImports, setFailedImports] = useState<any[]>([]);
    const [message, setMessage] = useState<string>('');

    useEffect(() => { setDocument({}) }, [])

    const safeString = (val: any, fallback: string = ""): string => {
        if (val === null || val === undefined || String(val).trim() === '') {
            return fallback;
        }
        return String(val).trim();
    };

    const createItem = async (bean: any) => {
        try {
            const resp = await taxCode.instance.addTaxCode(codeScheme, bean.Code, bean.Name, bean.Description);
            
            // Actualizar el estado de la lista de manera síncrona
            setImportado((prevList) => {
                const newList = [...prevList, resp];
                
                // Si el nuevo tamaño es múltiplo de 10, actualizar el mensaje
                if (newList.length % 10 === 0) {
                    setMessage(`Se han cargado ${newList.length} elementos.`);
                }
                
                return newList;
            });
           //console.log(resp);
            
            return resp; // Retornar la respuesta para saber que se completó
        } catch (error) {
            console.error('Error al crear el item:', error);
            throw error;
        }
    };

    const importDocument = async () => {
        setImportado([]);
        setFailedImports([]);
        setMessage('Iniciando importación...');

        const newArray = lista.slice(1);
        const limit = 10;
        const executing: Promise<any>[] = [];
        const failed: any[] = [];

        for (const element of newArray) {
            let b = {
                IDTaxCodeScheme: codeScheme,
                Code: safeString(element[0], "0000"),
                Name: safeString(element[1], "---"),
                Description: safeString(element[2], ""),
            };

            let p: Promise<any>;
            p = createItem(b)
                .catch((error) => {
                    const errorMsg = error?.response?.data?.DataBeanProperties?.ErrorMessage || 
                                     error?.response?.data?.message || 
                                     error?.message || 
                                     (typeof error === 'string' ? error : 'Error desconocido');
                    failed.push({ item: b, error: errorMsg });
                    console.error("Error al importar elemento:", b, error);
                })
                .finally(() => {
                    const index = executing.indexOf(p);
                    if (index > -1) {
                        executing.splice(index, 1);
                    }
                });

            executing.push(p);

            if (executing.length >= limit) {
                await Promise.race(executing);
            }
        }

        await Promise.all(executing);

        if (failed.length > 0) {
            setFailedImports(failed);
            setMessage(`Carga finalizada con observaciones. Se cargaron con éxito ${newArray.length - failed.length} de ${newArray.length} elementos.`);
        } else {
            setMessage(`Carga completa: se han cargado exitosamente los ${newArray.length} elementos.`);
        }
    }


    return (
        <div className="row">
            <div className="col-12">
                <TaxCodeSchemeEditor idSelector={codeScheme} onChange={(e) => { setCodeScheme(e) }} />
            </div>
            <div className="col-12">
                {/* <FileInput docAcept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" label="Cargar Documento de Codigos tipo excel" onCreate={(document) => { setDocument(document) }} /> */}
                <ImportXLSX lodaData={setLista} />
            </div>
            <div className="col-md-12">
                <BasicButton icon="" eventClick={() => { importDocument() }}>Confirmar</BasicButton>

                {message && (
                    <div className="mt-2">
                        <strong><small>{message}</small></strong>
                    </div>
                )}

                {failedImports.length > 0 && (
                    <div className="mt-3 alert alert-warning">
                        <h6 className="alert-heading font-weight-bold">Algunos elementos no pudieron importarse:</h6>
                        <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                            <table className="table table-sm table-striped mb-0 mt-2">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Detalle del Error</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {failedImports.map((fail, idx) => (
                                        <tr key={idx}>
                                            <td><code>{fail.item.Code}</code></td>
                                            <td>{fail.item.Name}</td>
                                            <td className="text-danger"><small>{fail.error}</small></td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={3} className="text-right text-muted">
                                            Total fallidos: {failedImports.length}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
            </div>

        </div>
    )
}